import { useMemo } from 'react';
import { localToday, weekStrip } from '@battleops/shared';
import { useTasks } from '../context/TaskContext';
import { useProjects } from '../context/ProjectContext';
import { useLocalCollection, useLocalDoc } from './useLocal';

/** The week strip on every Home (shared weekStrip): every job's dated tasks, events, jobs due and the forecast. */
export function useWeekStrip(date) {
  const { tasks } = useTasks();
  const { projects } = useProjects();
  const events = useLocalCollection('calendarEvents');
  const weather = useLocalDoc('weather', 'now');
  const today = localToday();
  return useMemo(() => weekStrip({ date: date || today, today, tasks, events, projects, weather }), [date, today, tasks, events, projects, weather]);
}
